export default __webpack_public_path__ + "static/media/DaciaBlock-Bold.ff0d4158.woff";